import { EWageRule } from '../../shared/payroll/e-wage-rule';

export class EmployeeWageRule extends EWageRule {
  employeeWageID: string;

  constructor(jsonData: Partial<EmployeeWageRule>) {
    super(jsonData);
  }
}
